.error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--gray-600);
}

.error h1 {
  font-size: 3rem;
  font-family: var(--font-text);
  font-weight: bold;
  line-height: 1.25;
  margin-bottom: 2rem;
}

.error h3 {
  font-size: var(--font-size-lg);
  color: var(--gray-600);
  font-weight: bold;
}

.error h4 {
  font-size: var(--font-size-md);
  color: var(--gray-600);
  font-weight: bold;
}

.error code {
  font-weight: bold;
}

.error p {
  font-size: var(--font-size-md);
  color: var(--gray-600);
  max-width: 38rem;
}

.error nav {
  margin-top: 2rem;
}

.error a {
  color: var(--gray-600);
}

.stack {
  flex: 1 1 auto;
  padding: 2.5rem 5rem;
  border-bottom: 1rem solid var(--bg-gray);
}

.stack h2 {
  font-size: 1.875rem;
  font-family: var(--font-text);
  font-weight: bold;
}

.stack code {
  font-family: "Courier New", Courier, monospace;
  line-height: 1.5rem;
}
